import React from 'react';

import { useLtcWallet } from '@/networks/btc-like/ltc';

import HeaderWalletDrawerLtcWalletConnect from './HeaderWalletDrawerLtcWalletConnect';
import HeaderWalletDrawerLtcWalletDetails from './HeaderWalletDrawerLtcWalletDetails/HeaderWalletDrawerLtcWalletDetails';

interface HeaderWalletDrawerLtcWalletProps {
  // Add any props you may need here
}

const HeaderWalletDrawerLtcWallet: React.FC<HeaderWalletDrawerLtcWalletProps> = () => {
  const { isConnected } = useLtcWallet();

  if (isConnected) {
    return <HeaderWalletDrawerLtcWalletDetails />;
  }

  return <HeaderWalletDrawerLtcWalletConnect className="h-14 w-full rounded-xl text-base" />;
};

export default HeaderWalletDrawerLtcWallet;
